export default __webpack_public_path__ + "img/f5af9857165fbe7a5e3b5a892087cd35.jpg";